// import { Role } from './lib/Role';
import { Role2 } from './lib/Role2';

export * from './lib/components';
export * from './lib/hooks';
// export default Role;
export default Role2;
